import { css, jsx } from '@emotion/react';
/** @jsxImportSource @emotion/react */
import { ButtonBase } from '@mui/material';
import React, { useRef, useState } from 'react';
import { Form, Input, message, Modal, Space, Table } from 'antd';
import { Pagination } from 'antd';
import Button from '@mui/material/Button';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../api/apiClient';
import endpoints from '../../api/endpoints';

import CustomInput from '../../components/CommonComponents/CustomInput';
import CustomTable from '../../components/CommonComponents/CustomTable';
import CustomButton from '../../components/CommonComponents/CustomButton';
import { getDecoded } from '../../util';
import CustomInput2 from '../../components/CommonComponents/CustomInput2';
import config from '../../config';
import Loader from '../../loader';

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState();
  const [username, setUsername] = useState(localStorage.getItem('list-username') || "");
  const [userId, setUserId] = useState(localStorage.getItem('list-userId') || "");
  const [page, setPage] = useState(localStorage.getItem('list-page') || 1);

  const navigate = useNavigate();

  const columns = [
    {
      title: "Id",
      dataIndex: 'user_id',
      key: 'user_id',
    },
    {
      title: "Name",
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: "Suspend",
      dataIndex: 'suspended',
      key: 'suspended',
      render: (suspended) => {
        const text = suspended == "0" ? "-" : 'suspended'
        return text;
      }
    },
    {
      title: <div style={{ textAlign: 'center' }}>Action</div>,
      render: (data) => {
        const viewColor = config.color.secondaryColor;
        return (
          <Space size="middle">
            <Button
              onClick={() => handleAction({ action: "view", data })}
              css={css`border-color: ${viewColor}; :hover { border-color: ${viewColor}; }`}
            >
              <i className="mdi mdi-eye" style={{color: viewColor, fontSize: "18px"}}></i>
            </Button>
          </Space>
        );
      },
    },
  ];

  const handleAction = (obj) => {
    const { action, data } = obj;
    if (action === "view") {
      navigate('/user/detail/' + data.user_id);
      return;
    }
  };

  async function fetchData() {
    setLoading(true);

    const res = await api.get(endpoints.agent.usersList + `?userId=${userId}&username=${username}&page=${page}`);
    setLoading(false);
    if(res.code !== "200") return message.error(res.message);

    setUsers(res.data.users);
    setTotalUsers(res.data.totalUsers);
  }

  const handleSearchUsername = async (v) => {
    setPage(1);
    setUsername(v);
    localStorage.setItem("list-username", v)
  };

  const handleSearchUserId = async (v) => {
    setPage(1);
    setUserId(v);
    localStorage.setItem("list-userId", v)
  };

  const handlePageChange = (v) => {
    setPage(v);
    localStorage.setItem('list-page', v)
  }

  useEffect(() => {
    fetchData();
  }, [page, userId, username]);

  const handleCreateNewUser = async () => {
    const UI = () => {
      const [loading, setLoading] = useState(false);
      const onFinish = async (values) => {
        console.log("values: ", values)
        let {username, password} = values;
        const accountKey = `${getDecoded().clientId}@${username}`;
        setLoading(true);
        const params = {
          username,
          accountKey: accountKey,
          password
        }
        const res = await api.post(endpoints.agent.userCreate, params);
        setLoading(false);
        if(res.code !== "200") return message.error(res.message);
        navigator.clipboard.writeText(`Username: ${accountKey}\nPassword: ${password}`);
        message.success("User Created Successfully And Copied!");
        fetchData();
        Modal.destroyAll();
        if(res.data?.userId) navigate('/user/detail/' + res.data?.userId);
      }
      return (
        <Form
        name="basic"
        onFinish={onFinish}
        autoCorrect='off'
        autoComplete="off"
        style={{marginTop: "1.5rem"}}
      >
        <Form.Item name={"username"} 
        rules={[
          {
            required: true,
            message: `Fill Username!`,
          },
        ]}>
          <CustomInput2  addonBefore={getDecoded()?.clientId} placeholder={"username..."}/>
        </Form.Item>
        <Form.Item name={"password"}
          rules={[
            {
              required: true,
              message: `Fill Password!`,
            },
            {
              min: 6,
              max: 15,
              message: "Password must have at least 6 characters",
            },
          ]}
        >
          <CustomInput2 password placeholder={"password..."}/>
        </Form.Item>
        {/* <Form.Item
          name="comfirmedPassword"
          rules={[
              {
                required: true,
                message: `Fill Password Again!`,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(`Must be same with above password!`));
                },
              }),
            ]}
        >
          <CustomInput2 password placeholder={"comfirm password..."}/>
        </Form.Item> */}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <CustomButton
            type="submit"
            component="button"
            disabled={loading}
            style={{color: config.color.textColor}}
          >
             {loading ? <Loader/> : "Save And Copy"}
          </CustomButton>
        </div>
      </Form>
      )
    }

    Modal.confirm({
      title: "Create New User",
      content: <UI/>,
      cancelButtonProps: {style: {display: "none"}},
      okButtonProps: {style: {display: "none"}},
      centered: true,
      closable: true,
      closeIcon: <i className="mdi mdi-close-thick" style={{fontSize: "18px", color: config.color.textColor}}></i>
    });

  }


  return (
    <div style={{marginTop: "70px"}} css={css` color: white; padding: 1rem; min-height: 100vh;`}>
      <div>
        <div  className='d-flex flex-column flex-md-row flex-lg-row align--start justify-content-lg-between justify-content-md-between align-items-start align-items-lg-center'  css={css`display: flex; margin-bottom: 1.5rem; margin-top: 1rem; align-items: center;`}>
          <div className='d-flex flex-column flex-md-row' style={{alignItems: 'center', gap: "20px"}}>

              <CustomInput
               value={username}
               placeholder={"Username..."}
               onChange={(e) => handleSearchUsername(e.currentTarget.value)}
               search
              />

              <CustomInput
               value={userId}
               placeholder={"User Id..."}
               onChange={(e) => handleSearchUserId(e.currentTarget.value)}
               search
              />
              
          </div>

          <CustomButton onClick={handleCreateNewUser} className={"mt-3 mt-md-0 mt-lg-0"}>
            {<i className="mdi mdi-plus" style={{marginRight: "4px"}}></i>}{"New User"}
          </CustomButton>

        </div>

        <CustomTable
          data={users}
          columns={columns}
          loading={loading}
          handlePageChange={handlePageChange}
          page={page}
          totalUsers={totalUsers}
        />
   
      </div>
    </div>
  );
}

